import * as React from 'react';
// import IconSprite from './iconsprite.svg';

import { getIcon } from './getIcons';

interface BaseProps {
  /**
   * Any custom classes
   */
  classNames?: string;

  /**
   * Cypress data attribute for testing
   */
  'data-cy'?: string;

  /**
   * React Testing Library data attribute for testing
   */
  'data-testid'?: string;

  /**
   * ID for the icon
   */
  id?: string;

  /**
   * Height for the icon
   */
  height?: string;

  /**
   * Width for the icon
   */
  width?: string;
}

export interface IconProps extends BaseProps {
  /**
   * The path to the icon to render
   */
  name: string;

  /**
   * Title of the icon for the hover tooltip
   */
  title?: string;
}

const Icon: React.FC<IconProps> = ({ ...props }) => {
  return <>{getIcon(props)}</>;
};

export default Icon;
